import { render, staticRenderFns } from "./BlacklistStats.vue?vue&type=template&id=740ae670&scoped=true"
import script from "./BlacklistStats.vue?vue&type=script&lang=js"
export * from "./BlacklistStats.vue?vue&type=script&lang=js"
import style0 from "./BlacklistStats.vue?vue&type=style&index=0&id=740ae670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ae670",
  null
  
)

export default component.exports